export class IFramePlayerEventDataVO {
    utagData;
    smartTag;
    importResult;
    paramsVO;
    error;
}
